import { useState, useEffect } from "react";
import Sidebar from "./partials/Sidebar";
import Report from "./partials/Report";
import RenderLoading from "./partials/RenderLoading";

const OverallReport = ({ report }) => {
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Preload the image before showing any content
    const imageUrl = report.userDetails.photoUrl || "../../../../assets/default-img.jpg";
    const img = new Image();
    img.src = imageUrl;
    
    const handleImageLoad = () => {
      setIsLoading(false);
    };
    
    img.onload = handleImageLoad;
    img.onerror = handleImageLoad; // Handle error case as well
    
    // Clean up
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [report.userDetails.photoUrl]);
  
  if (isLoading) {
    return (
      <RenderLoading/>
    );
  }
  
  return (
    <div className="mx-auto">
      <div className="flex gap-6">
        <Sidebar report={report.userDetails} />
        <div className="w-4/5">
          <Report report={report} />
        </div>
      </div>
    </div>
  );
};

export default OverallReport;